import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'

/**
 * receives transaction prop from transactionSwitcher
 * this component deals with displaying user transactions
 */
class UserTransaction extends Component {
    constructor(props) {
        //console.log("UserTransaction constructor " + props);
        super(props);
        this.state = {
            transactions: []
        };
    }

    componentDidMount() {
        //console.log("UserTransaction componentDidMount");
        //allows transactions to persist
        this.setState({
            transactions: this.props.transaction
        });

    }

    componentWillReceiveProps(nextProps) {
        //console.log("UserTransaction componentWillReceiveProps " + nextProps);
        //on nextProps, set the state to be rendered

        //console.log(nextProps);
        let trns = [];
        console.log(trns);
        trns.push(nextProps);
        //console.log("trns",trns);
        //console.log("trns[0]",trns[0]);
        this.setState({
            transactions: trns[0]['transaction']
        });
    }


    render() {
      let typeClass = function(trnType){
        switch(trnType){
          case 'Sell':
            return 'sell-transaction transaction-log-row';
          case 'Buy':
            return 'buy-transaction transaction-log-row';
          case 'Bid':
            return 'bid-transaction transaction-log-row';
          case 'Ask':
            return 'ask-transaction transaction-log-row';
        }
      };
      let typeVerb = function(trnType){
        switch(trnType){
          case 'Sell':
            return 'Sold';
          case 'Buy':
            return 'Bought';
          case 'Bid':
            return 'Bid for';
          case 'Ask':
            return 'Offered';
        }
      }
      return (
        <div style={{"overflow-x": "auto"}}>
        <div style={{ height: "25em", overflowY: "auto" }}>
          <table className="market-transactions-table">
          <thead>
              <tr>
                <th className="market-transactions-header">Timestamp</th>
                <th className="market-transactions-header">Volume</th>
                <th className="market-transactions-header">Symbol</th>
                <th className="market-transactions-header">Type</th>
                <th className="market-transactions-header">Price</th>
              </tr>
          </thead>

          <tbody>
            {this.state.transactions.map((trn, index) => {
              let rowColor = '';
              switch(trn.Type) {
                case 'Sell': rowColor = '#EF4444'; break;
                case 'Buy': rowColor = '#31BA7F'; break;
                case 'Bid': rowColor = '#2B4365'; break;
                case 'Ask': rowColor = '#744210'; break;
                default: rowColor = '#FFFFFF';
              }
              return (
                <tr className={'market-transactions-row'} key={index}>
                    <td className="market-transactions-data">{trn.Time.substr(11,5)}</td>
                    <td className="market-transactions-data">{trn.Volume} shares of</td>
                    <td className="market-transactions-data">carbon credits were</td>
                    <td style={{"color": rowColor, }} className="market-transactions-data">{typeVerb(trn.Type)} at</td>
                    <td style={{"color": rowColor, }} className="market-transactions-data">${(trn.Price / 100).toFixed(2)}</td>
                  </tr>
              )
            })}
          </tbody>
        </table>
        </div>
        </div>

      )
    }
}

UserTransaction.propTypes = {
    nextProps: PropTypes.array
};

export default UserTransaction;



// WEBPACK FOOTER //
// ./src/components/Orderbook/UserTransactions.js